import { useExperiencesContext } from '../../../experiences/Experiences';
import {
  useFacetContext,
  useProductContext,
  useSearchContext,
} from '../../../../context/PlpContext';
import { usePlpViewType } from '../../../../hooks/usePlpViewType';
import { SelectedFacet } from 'src/utils/types/types';

type ControlsData = {
  experiences: {
    isHideTopPaginationFlagOn: boolean;
    isListViewEnabled: boolean;
    isProductCardSizeFlagOn: boolean;
    isReplaceTopPaginationFlagOn: boolean;
    isTabletEnhancementsFlagOn: boolean;
    isSingleColumnLayout: boolean;
  };
  facetContext: {
    baseFacetId: string;
    isMoreFiltersButton: boolean;
  };
  plpViewType: {
    hasPlpViewTypeSelection: boolean;
  };
  productContext: {
    totalNumberOfResults: number;
  };
  searchContext: {
    filter: SelectedFacet;
  };
};

export const useControlsData = (): ControlsData => {
  const {
    isHideTopPaginationFlagOn,
    isListViewEnabled,
    isProductCardSizeFlagOn,
    isReplaceTopPaginationFlagOn,
    isTabletEnhancementsFlagOn,
    isSingleColumnLayout,
  } = useExperiencesContext();

  const { baseFacetId, isPrimaryFacetInDiscoResponse: isMoreFiltersButton } =
    useFacetContext();

  const { hasPlpViewTypeSelection } = usePlpViewType('useControlsData');

  const { totalNumberOfResults } = useProductContext();

  const { filter } = useSearchContext();

  return {
    experiences: {
      isHideTopPaginationFlagOn,
      isListViewEnabled,
      isReplaceTopPaginationFlagOn,
      isProductCardSizeFlagOn,
      isTabletEnhancementsFlagOn,
      isSingleColumnLayout,
    },
    facetContext: {
      baseFacetId,
      isMoreFiltersButton,
    },
    plpViewType: {
      hasPlpViewTypeSelection,
    },
    productContext: {
      totalNumberOfResults,
    },
    searchContext: {
      filter,
    },
  };
};
